import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
    Input,
    Row,
    Card,
    Form,
    Select,
    Col,
    Divider,
    Spin,
    DatePicker,
    Button,
    Typography
} from "antd";

//ANT DESIGN ICONS IMPORT
import { LeftOutlined } from "@ant-design/icons";

//OTHER IMPORTS
import dayjs from 'dayjs';

//PROJECT IMPORTS
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import CustomButton from "../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import { accountStatus } from "../../../../../components/facilities/AccountFacility";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";


const CloseFixedDepositAcc = (props) => {
    const { TextArea } = Input;
    const { userData } = props;
    const { session } = userData;
    const { Text } = Typography;
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [isDateSubmitted, setIsDateSubmitted] = useState(false);
    const [isTransferToSavingsSelected, setIsTransferToSavingsSelected] = useState(false);
    const [actionOptions, setActionOptions] = useState([]);
    const [transferToSavingsOptions, setTransferToSavingsOptions] = useState([]);
    const [onAccountClosureId, setOnAccountClosureId] = useState();
    const dateFormat = 'YYYY/MM/DD';

    useEffect(() => {
        defaultDate()
    }, []);

    function onCancel() {
        navigate("/detail-fixed-deposit-account", { state: state });
    }
    const defaultDate = () => {
        form.setFieldsValue({
            closedOnDate: dayjs(),
        })
    }
    const disabledAfterCurrentDate = (current) => {
        return current && current.valueOf() > Date.now();
    };

    const handleOnChange = (value, option) => {

        if (option?.label.toLowerCase() === "transfer to savings") {
            setIsTransferToSavingsSelected(true)
        } else {
            setIsTransferToSavingsSelected(false)
        };
        setOnAccountClosureId(value)

    }

    const displayValue = (value, option) => {
        console.log(value);

    }

    const preOnSubmit = (formValues) => {

        const params = {
            command: "calculatePrematureAmount",
        };
        const url = `${apiConfig.FixedDepositAccounts}/${state.id}`;

        let body = {
            closedOnDate: BOM.DateTime(
                formValues.closedOnDate,
                "only-date"
            ),
            dateFormat: "dd MMMM yyyy",
            locale: "en",
            session,
            method: "POST",
            params,
        };
        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                const objDetail = res;
                setIsDateSubmitted(true)

                let tempActionOptions = [];
                let tempTranferToSavingsOptions = [];

                objDetail?.onAccountClosureOptions?.forEach((element) => {
                    tempActionOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objDetail?.savingsAccounts?.forEach((element) => {
                    tempTranferToSavingsOptions.push({
                        value: element.id,
                        label: element.accountNo,
                    });
                });

                form.setFieldsValue({
                    maturityAmount: objDetail?.maturityAmount ? objDetail?.maturityAmount : " - ",
                    onAccountClosureId: objDetail?.onAccountClosureOptions[0].value
                        ? objDetail?.onAccountClosureOptions[0].value
                        : " - ",
                })
                setOnAccountClosureId(objDetail?.onAccountClosureOptions[0].id);
                setActionOptions(tempActionOptions);
                setTransferToSavingsOptions(tempTranferToSavingsOptions)
                setIsLoading(false);
            }
        });

    };

    const onSubmit = (formValues) => {

        const url = `${apiConfig.FixedDepositAccounts}/${state.id}`;
        const params = {
            command: "close",
        };

        let body = {
            closedOnDate: BOM.DateTime(
                formValues.closedOnDate,
                "only-date"
            ),
            onAccountClosureId: onAccountClosureId,
            toSavingsAccountId: formValues.transferToSavings,
            note: formValues.note,
            transferDescription: formValues.transferDescription,
            dateFormat: "dd MMMM yyyy",
            locale: "en",
            session,
            method: "POST",
            params,
        };
        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.closeFixedDepositMsg);
                navigate("/detail-fixed-deposit-account", {
                    state: { ...state, statusValue: accountStatus.closed },
                });
                //STOP LOAD
                setIsLoading(false);
            }
        },
        {
                navigate,
                showCheckerModal: showCheckerApprovalModal,
                onCheckerApproval: (res) => {
                  // navigate("/sms0100");
                  navigate("/detail-fixed-deposit-account", {
                    state: { ...state, statusValue: accountStatus.closed },
                });
                  setIsLoading(false);
                },
              }
    );

    };

    return (
        <MainLayout isEnableRightSidebar={true}>
            <TopContent
                pageTitle={labelConfig.closeFixedDeposit}
                pageItems={staticConfig.closeFixedDepositAccountBreadcrumbItems}
            />

            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}
                    title={
                        <Row
                            style={{
                                alignContent: "center",
                                width: "8%",
                            }}
                        >
                            <Button
                                icon={<LeftOutlined />}
                                type="text"
                                style={{
                                    marginTop: "auto",
                                    marginBottom: "auto",
                                }}
                                onClick={onCancel}
                            >
                                <Text
                                    style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                                >
                                    Back
                                </Text>
                            </Button>
                        </Row>
                    }
                >
                    <Form form={form} layout="vertical" onFinish={isDateSubmitted ? onSubmit : preOnSubmit}>
                        <Row>
                            <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.closedDate}
                                    name="closedOnDate"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.closedDate),
                                        },
                                    ]}
                                >
                                    <DatePicker
                                        disabledDate={disabledAfterCurrentDate}
                                        style={{ width: "100%", height: 35 }}
                                        format={dateFormat}
                                    />
                                </Form.Item>
                            </Col>
                            {isDateSubmitted &&
                                <>
                                    <Col span={8} style={{ padding: "0px 8px" }}>
                                        <Form.Item
                                            label={labelConfig.maturityAmount}
                                            name="maturityAmount"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: BOM.CheckReqFld(labelConfig.maturityAmount),
                                                },
                                            ]}
                                        >
                                            <Input disabled />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8} style={{ padding: "0px 8px" }}>
                                        <Form.Item
                                            label={labelConfig.action}
                                            name="onAccountClosureId"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: BOM.CheckReqFld(labelConfig.action),
                                                },
                                            ]}
                                        >
                                            <Select
                                                filterOption={(input, option) =>
                                                    (option?.label?.toLowerCase() ?? "").includes(
                                                        input?.toLowerCase()
                                                    )
                                                }
                                                placeholder={BOM.handlePlaceholderMsg(
                                                    labelConfig.action,
                                                    "select"
                                                )}
                                                options={actionOptions}
                                                showSearch
                                                onChange={handleOnChange}
                                            />
                                        </Form.Item>
                                    </Col>
                                    {isTransferToSavingsSelected &&
                                        <>
                                            <Col span={8} style={{ padding: "0px 8px" }}>
                                                <Form.Item
                                                    label={labelConfig.transferToSavings}
                                                    name="transferToSavings"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: BOM.CheckReqFld(labelConfig.transferToSavings),
                                                        },
                                                    ]}
                                                >
                                                    <Select
                                                        filterOption={(input, option) =>
                                                            (option?.label?.toLowerCase() ?? "").includes(
                                                                input?.toLowerCase()
                                                            )
                                                        }
                                                        placeholder={BOM.handlePlaceholderMsg(
                                                            labelConfig.transferToSavings,
                                                            "select"
                                                        )}
                                                        options={transferToSavingsOptions}
                                                        showSearch
                                                        onChange={displayValue}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={8} style={{ padding: "0px 8px" }}>
                                                <Form.Item
                                                    label={labelConfig.transferDescription}
                                                    name="transferDescription"
                                                >
                                                    <TextArea rows={3} />
                                                </Form.Item>
                                            </Col>

                                        </>
                                    }
                                    <Col span={8} style={{ padding: "0px 8px" }}>
                                        <Form.Item
                                            label={labelConfig.note}
                                            name="note"
                                        >
                                            <TextArea rows={3} />
                                        </Form.Item>
                                    </Col>
                                </>
                            }
                        </Row>

                        <Row>
                            <Divider />
                            <CustomButton
                                content={`${isDateSubmitted ? "Submit" : "Next"}`}
                                style={{
                                    width: "10%",
                                    marginLeft: "auto",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                htmlType="submit"
                                backgroundColor="#92428B"
                                colorText="white"
                                hoverBackground="#AD4EA7"
                            />
                            <CustomButton
                                content="Cancel"
                                style={{
                                    width: "10%",
                                    marginLeft: "1%",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                backgroundColor="#fff"
                                colorText="black"
                                hoverBackground="#F5F5F5"
                                onClick={onCancel}
                            />
                        </Row>
                    </Form>
                </Card>
            </Spin>
        </MainLayout>
    );
};

export default CloseFixedDepositAcc;
